<template>
	<form class="container-sm mh-100 pt-10" @submit.prevent="submit" autocomplete="off">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">Recuperar acceso</div>
			<div class="card text-bg-white border-0 shadow-none">
				<div class="card-body vstack gap-5">
					<div class="vstack gap-3">
						<CommonFormInputText v-model="target.code" title="Código" placeholder="Ingrese el código" :focus="true" :validation="validation.code" />
					</div>
					<div class="text-center" v-if="validationExternal.length > 0">
						<div class="invalid-feedback fw-bold d-block m-0" v-for="(error, index) in validationExternal" v-bind:key="index">{{ error }}</div>
					</div>
					<div class="text-center d-grid gap-3">
						<button type="submit" class="btn btn-md btn-primary" :disabled="submitting">Recuperar acceso</button>
					</div>
					<div class="text-center text-dark">
						<template v-if="sent">Ingresá el código que te enviamos a<br /><b>{{ target.email }}</b></template>
						<template v-else>Enviando código</template>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center fw-bold pb-10">
			¿Ya tienes una cuenta?
			<router-link :to="{ name: 'auth.login' }" class="link-primary ps-2">Ingresar</router-link>
		</div>
	</form>
</template>

<script>
	import { ref, reactive, computed, onBeforeMount } from 'vue';
	import store from '@/store';
	import router from '@/router';
	import { useRoute } from 'vue-router';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import ModelRepository from '@/repositories/modules/Auth';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const route = useRoute();
			const sent = ref(false);

			const target = reactive({
				email: route.query?.email,
				code: ''
			});

			const validation = useVuelidate({
				code: {
					required,
					minLength: minLength(1),
					maxLength: maxLength(6)
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				await ModelRepository.recoverCheck(target).then((response) => {
					store.dispatch('auth/setToken', response.data);
					setUser();
				}).catch((e) => {
					catchError(e);
					submitting.value = false;
				});
			}

			const setUser = () => {
				store.dispatch('auth/me').then((response) => {
					router.push({ name: 'account.setting.index' });
				}).catch(catchError);
			}

			onBeforeMount(() => {
				ModelRepository.recoverSend({ email: target.email }).then((response) => {
					sent.value = true;
				}).catch((e) => catchError(e, true));
			});

			return { sent, target, validation, validationExternal, submitting, submit };
		}
	}
</script>